import * as actionType from "../types/ActionTypes";

const initialState = {
  batches: [],
  postBatches: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const Batches = (state = initialState, action) => {
  switch (action.type) {
    case actionType.BATCHES_SET_DATA:
      return {
        ...state,
        batches: action.batches,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.BATCHES_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.BATCHES_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.BATCHES_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.BATCHES_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_BATCHES_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_BATCHES_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postBatches: action.postBatches,
      };
    case actionType.UPDATE_BATCHES_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_BATCHES_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_BATCHES_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
